module.exports = __webpack_public_path__ + "./img/plus.5c41db63c6a80b89e25016780daf5382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus.png
// module id = ./src/assets/plus.png
// module chunks = 0